const slider = document.querySelector('.bottle-text-mobile-slideshow');

if (slider){
  const track = slider.querySelector('.mobile-column');
  const slides = Array.from(track.children).filter(el => el.tagName === 'DIV');


  let index = 0;

  const dotsWrap = document.createElement('div');
  dotsWrap.className = 'js-dots';
  slider.appendChild(dotsWrap);

  slides.forEach((_, i) => {
    const dot = document.createElement('button');
    dot.classList.add('slider-dot');
    if (i === 0) dot.classList.add('active');
    dotsWrap.appendChild(dot);

    dot.addEventListener('click', () => {
      index = i;
      update();
    });
  });

  const dots = Array.from(dotsWrap.children);

  function update() {
    track.style.transform = `translateX(-${index * 100}%)`;
    dots.forEach(d => d.classList.remove('active'));
    dots[index].classList.add('active');
  }

  let startX = 0;

  track.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
  });

  track.addEventListener('touchend', e => {
    const diff = startX - e.changedTouches[0].clientX;

    if (diff > 50 && index < slides.length - 1) index++;
    if (diff < -50 && index > 0) index--;

    update();
  });
}
